import { GenericValue } from 'hisng';
import { PersonProfileEntryValue } from './personprofile-entry-value';

export class PersonProfileEntry { 
    id?: number;
    entrytext?: string;
    personProfileEntryValue?: PersonProfileEntryValue;
    language?: GenericValue;
    
    _foreigntext: any;
}
